import type { IconProps } from '@chakra-ui/icons'
import { createIcon } from '@chakra-ui/icons'
import type { ComponentWithAs } from '@chakra-ui/react'

export const Hamburger: ComponentWithAs<'svg', IconProps> = createIcon({
  displayName: 'HamburgerMenu',
  viewBox: '0 0 34 8',
  path: <path fill="currentColor" d="M0 0h34v2H0zM0 6h34v2H0z" />,
})
